module.exports = __webpack_public_path__ + "sourya.png?1cd1b727f5b26bfb5801a56fa0741e08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sourya.png
// module id = 167
// module chunks = 0